import { getWebViewType } from "../getWebViewType";
import { window } from "../window";

export const openDeepLink = (options) => {
  const { href, opensNewTab } = options;
  const webViewType = getWebViewType();
  const target = opensNewTab ? "_blank" : "_self";

  if (!!webViewType) {
    const linkElement = window.document.createElement("a");

    linkElement.href = href;
    linkElement.target = target;

    linkElement.click();
  } else {
    window.open(href, target);
  }
};
